import { render, staticRenderFns } from "./PSocialLinks.vue?vue&type=template&id=2711f190&scoped=true&"
import script from "./PSocialLinks.vue?vue&type=script&lang=ts&"
export * from "./PSocialLinks.vue?vue&type=script&lang=ts&"
import style0 from "./PSocialLinks.vue?vue&type=style&index=0&id=2711f190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2711f190",
  null
  
)

export default component.exports